// extracted by mini-css-extract-plugin
export default {"key":"Keyboard_key__LFGSt"};